import React, { Component } from 'react';
import styled from 'styled-components';

const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5;
`;

const IMAGE = styled.img`
  max-width: 100%;
  height: auto;
  margin: 0.2em 0;
  border-radius: 16px;
`;

export default class Pictures extends Component {
  render() {
    return (
      <GalleryContainer>
        <IMAGE src={require('../img/IMG_7735.png')} />
        <IMAGE src={require('../img/IMG_7865_cropped.png')} />
        <IMAGE src={require('../img/sec_cam_cropped.png')} />
        <IMAGE src={require('../img/9gzT9.png')} />
        <IMAGE src={require('../img/IMG_7738.png')} />
      </GalleryContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pictures.js